module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Tablet-04190348fb2cee3fef23564f0aa67b0c.svg";